import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, Data, RoutesRecognized } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

export enum Layouts {
  DaylilyLayout,
  FeedLayout
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {
  Layouts = Layouts
  layout: Layouts = Layouts.DaylilyLayout;

  constructor(private router: Router) { }

  // We can't use `ActivatedRoute` here since we are not within a `router-outlet` context yet.
  ngOnInit() {
    this.router.events.subscribe((data) => {
      if (data instanceof RoutesRecognized) {
        console.log ( data );
        if (data.url == "/feed") {
          this.layout = Layouts.FeedLayout; 
          //console.log ("feed requested");
          //console.log (this);
        }
      }
    });
  }

}